var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendSap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 75,
    viewBox: "0 0 78 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 37.5V63C0 69.6274 5.37259 75 12 75H38.523H65.0459C71.6734 75 77.0459 69.6274 77.0459 63V37.5V12C77.0459 5.37258 71.6733 0 65.0459 0H38.523H12C5.37258 0 0 5.37259 0 12V37.5Z",
    fill: "#3AE180"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4519 49.7963C46.4519 54.6426 42.8996 58.5758 38.5226 58.5758H27.4216C23.0446 58.5758 19.4922 54.6426 19.4922 49.7963V37.505C19.4922 32.6587 23.0446 28.7255 27.4216 28.7255H29.0074C29.8797 28.7255 30.5933 29.5157 30.5933 30.4814C30.5933 31.4472 29.8797 32.2373 29.0074 32.2373H27.4216C24.8049 32.2373 22.664 34.6078 22.664 37.505V49.7963C22.664 52.6935 24.8049 55.064 27.4216 55.064H38.5226C41.1393 55.064 43.2802 52.6935 43.2802 49.7963C43.2802 48.8305 43.9938 48.0404 44.8661 48.0404C45.7383 48.0404 46.4519 48.8305 46.4519 49.7963ZM56.1733 26.7765L47.5937 16.961C46.9911 16.2587 45.9762 16.2411 45.3577 16.9259C44.7392 17.6107 44.7075 18.7169 45.326 19.4017L53.4773 28.708H40.1085C35.7315 28.708 32.1792 32.6412 32.1792 37.4875V46.2669C32.1792 47.2327 32.8928 48.0228 33.765 48.0228C34.6372 48.0228 35.3509 47.2327 35.3509 46.2669V37.4875C35.3509 34.5902 37.4918 32.2198 40.1085 32.2198H53.4614L45.3101 41.526C44.7075 42.2284 44.7075 43.3346 45.3418 44.0018C45.6431 44.3354 46.0555 44.4935 46.4519 44.4935C46.8484 44.4935 47.2766 44.3179 47.5937 43.9667L56.1574 34.1864C58.0129 32.132 58.0129 28.7958 56.1733 26.7589V26.7765Z",
    fill: "#3AE180",
    stroke: "#3AE180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSap);
export default __webpack_public_path__ + "static/media/send_Sap.f595c639fe7236d7b870a9f009aaafc7.svg";
export { ForwardRef as ReactComponent };